var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellPm009(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 14.8731C14.6992 14.8731 16.8732 14.2703 17.0832 11.8505C17.0832 9.43241 15.5675 9.58791 15.5675 6.62101C15.5675 4.30353 13.3709 1.66675 9.99984 1.66675C6.62881 1.66675 4.43221 4.30353 4.43221 6.62101C4.43221 9.58791 2.9165 9.43241 2.9165 11.8505C3.1273 14.2794 5.30132 14.8731 9.99984 14.8731Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9904 17.3811C10.8536 18.6434 9.08027 18.6583 7.93262 17.3811",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellPm009);
export default __webpack_public_path__ + "static/media/bell-pm009.9d96d0c4684028130653bb51f7ffbd95.svg";
export { ForwardRef as ReactComponent };